import React, { useState, useImperativeHandle } from 'react';
import './../../styles/Inputs.css';

function Number({ label, defaultValue, gridWidth, icon , onChange , visible } , ref ) {
    const startValue = defaultValue ?? '';
    const [ value, setValue ] = useState( startValue );
    
    useImperativeHandle(ref, () => ({
        getValue: () => value,
        setValue: ( newVal ) => setValue( newVal ),
    }));

    const handleChange = ( e ) => {
        const value = e.target.value;
        if ( value === '' || parseFloat( value ) > 0) {
            setValue( value );
            if (typeof ( onChange ) === 'function') {
                onChange( value );
            }
        }
    };

    const containerClass = [
        'textfield',
        gridWidth === 'HALF' ? 'half' : 'full',
        visible === false ? 'hidden' : ''
    ].join(' ').trim();

    return (
        <div className={containerClass}>
            {label != null && (
                <label className="textfield-label">
                    {icon != null && 
                        <span className="textfield-icon">
                            <div dangerouslySetInnerHTML={ { __html: icon } }></div>
                        </span>}
                    {label}
                </label>
            )}

            <input
                type="number"
                min={1}
                className="textfield-input"
                value={value}
                onChange={ handleChange }
            />
        </div>
    );
}

export default React.forwardRef(Number);